module.exports = __webpack_public_path__ + "static/media/twitter.dcb0d6a8.svg";